export default function escape(path) {
  document.addEventListener("keyup", (e) => {
    e.preventDefault();
    e.code === "Escape" && window.location.replace(path);
  });
}